<template>
  <div class="rist" :style="{ '--base-color': $theme.basecolor, '--base-dark': $theme.basedark, '--base-light': $theme.baselight }">
    <!-- -------------------------------------------- E R R O R E -------------------------------------------- -->
    <div v-if="errore" class="rist-card shadow rist-messaggio">
      <fa :icon="['fas', 'exclamation-triangle']" class="rist-icona-grande" />
      <div>{{ t(errore) }}</div>
    </div>

    <!-- -------------------------------------------- G R A Z I E -------------------------------------------- -->
    <div v-else-if="fatta" class="rist-card shadow rist-messaggio">
      <fa :icon="['fas', fatta.stato === 'A' ? 'hourglass-half' : 'check-circle']" class="rist-icona-grande" />
      <h2>{{ fatta.stato === "A" ? t("RIST_GrazieAttesa") : t("RIST_Grazie") }}</h2>
      <div class="rist-riepilogo">
        <div><span>{{ t("RIST_Data") }}</span><b>{{ dataLunga(fatta.data) }}</b></div>
        <div><span>{{ t("RIST_Servizio") }}</span><b>{{ t("RIST_" + fatta.servizio) }}</b></div>
        <div><span>{{ t("RIST_Orario") }}</span><b>{{ fatta.orario }}</b></div>
        <div><span>{{ t("RIST_Persone") }}</span><b>{{ fatta.persone }}</b></div>
      </div>
      <p v-if="emailInviata">{{ t("RIST_EmailInviata") }}</p>
      <div class="rist-btn" @click="ricomincia">{{ t("RIST_Nuova") }}</div>
    </div>

    <template v-else-if="pronta">
      <!-- -------------------------------------------- Q U A N D O -------------------------------------------- -->
      <div class="rist-card shadow">
        <h2 class="rist-titolo"><fa :icon="['fas', 'utensils']" /> {{ t("RIST_Titolo") }}</h2>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-if="nota" class="rist-nota" v-html="nota" />
        <div class="rist-riga">
          <label class="rist-campo">
            <span>{{ t("RIST_Data") }}</span>
            <input v-model="data" type="date" :min="oggi" :max="ultimo" @change="caricaDisponibilita" />
          </label>
          <div class="rist-campo">
            <span>{{ t("RIST_Persone") }}</span>
            <div class="rist-contatore">
              <fa class="click" :icon="['fas', 'minus']" @click="cambiaPersone(-1)" />
              <b>{{ persone }}</b>
              <fa class="click" :icon="['fas', 'plus']" @click="cambiaPersone(1)" />
            </div>
          </div>
          <label v-if="sale.length" class="rist-campo">
            <span>{{ t("RIST_Sala") }}</span>
            <select v-model="idsala" @change="caricaDisponibilita">
              <option :value="0">{{ t("RIST_SalaNessuna") }}</option>
              <option v-for="s in sale" :key="s.id" :value="s.id">{{ s.descrizione }}</option>
            </select>
          </label>
        </div>
        <div class="rist-sub">
          {{ t("RIST_Gruppo").replace("%{max}", maxPersone) }}<span v-if="telefono"> {{ telefono }}</span>
        </div>
        <div v-if="sale.length && idsala" class="rist-sub">{{ t("RIST_SalaNota") }}</div>

        <!-- Pasti e orari della giornata -->
        <div v-if="caricamento" class="rist-sub rist-attesa"><fa :icon="['fas', 'spinner']" spin /></div>
        <div v-else-if="chiuso" class="rist-avviso">{{ t("RIST_Chiuso") }}</div>
        <div v-else>
          <div v-for="s in servizi" :key="s.id" class="rist-servizio">
            <div class="rist-servizio-nome">{{ t("RIST_" + s.id) }}</div>
            <div v-if="s.chiuso" class="rist-sub">{{ t("RIST_ServizioChiuso") }}</div>
            <div v-else-if="s.disponibile" class="rist-orari">
              <div v-for="o in s.orari" :key="o" class="rist-orario" :class="{ scelto: scelta.servizio === s.id && scelta.orario === o }" @click="scegli(s.id, o)">
                {{ o }}
              </div>
            </div>
            <div v-else class="rist-sub">
              {{ t("RIST_NonDisp") }}. {{ t("RIST_NonDispNota") }}<span v-if="telefono"> {{ telefono }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- -------------------------------------------- C H I -------------------------------------------- -->
      <div v-if="scelta.orario" ref="dati" class="rist-card shadow">
        <h2 class="rist-titolo"><fa :icon="['fas', 'user']" /> {{ t("RIST_Dati") }}</h2>
        <div class="rist-scelta">
          {{ iniziale(dataLunga(data)) }} · {{ t("RIST_" + scelta.servizio) }} {{ scelta.orario }} · {{ persone }} {{ t("RIST_Persone").toLowerCase() }}
        </div>
        <div class="rist-riga">
          <label class="rist-campo largo" :class="{ 'rist-err': errori.nome }">
            <span>{{ t("RIST_Nome") }} *</span>
            <input v-model.trim="form.nome" type="text" maxlength="100" autocomplete="name" />
          </label>
          <label class="rist-campo" :class="{ 'rist-err': errori.telefono }">
            <span>{{ t("Tel") }} *</span>
            <input v-model.trim="form.telefono" type="tel" maxlength="30" autocomplete="tel" />
          </label>
          <label class="rist-campo" :class="{ 'rist-err': errori.email }">
            <span>{{ t("Email2") }} *</span>
            <input v-model.trim="form.email" type="email" maxlength="150" autocomplete="email" />
          </label>
        </div>
        <label class="rist-campo largo">
          <span>{{ t("RIST_Note") }}</span>
          <textarea v-model="form.note" rows="2" maxlength="1000" />
        </label>
        <!-- Campo civetta: invisibile alle persone, i programmi lo riempiono. -->
        <input v-model="form.sito" type="text" name="sito" class="rist-civetta" tabindex="-1" autocomplete="off" />
        <div v-if="privacy" class="rist-privacy">
          <div class="rist-sub"><b>{{ t("Privacy") }}</b></div>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="rist-privacy-testo" v-html="privacy" />
        </div>
        <label class="rist-accetto" :class="{ 'rist-err': errori.privacy }">
          <input v-model="form.privacy" type="checkbox" />
          {{ t("Accettare") }}
        </label>
        <div v-if="messaggi.length" class="rist-avviso">
          <div v-for="m in messaggi" :key="m">{{ t(m) }}</div>
        </div>
        <div class="rist-btn" :class="{ disabilitato: invio }" @click="prenota">
          <fa v-if="invio" :icon="['fas', 'spinner']" spin />
          {{ t("RIST_Prenota") }}
          <fa :icon="['fas', 'chevron-right']" />
        </div>
        <div class="rist-sub rist-centro">{{ t("Campiobbligatori") }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import apiService from "../services/api";
import paginaService from "../services/pagina";

/** Lingua del Booking -> lingua del browser, per le date. */
const LOCALI = { ita: "it-IT", ing: "en-GB", eng: "en-GB", ted: "de-DE", fra: "fr-FR", spa: "es-ES", por: "pt-PT", jap: "ja-JP" };

/**
 * Prenotazione online di un tavolo del ristorante dell'hotel.
 *
 * Si apre come il Booking: /ristorante?RPC_db=...&idhotel=...&lan=ita (o con
 * gli stessi dati in POST dal sito dell'hotel). Il cliente sceglie giorno,
 * persone e orario tra quelli dei pasti ancora disponibili, poi lascia i suoi
 * dati. Il tavolo lo assegna il gestionale.
 */
export default {
  data() {
    return {
      pronta: false,
      errore: "",
      testi: {},
      servizi: [],
      maxPersone: 8,
      oggi: "",
      ultimo: "",
      sale: [],
      nota: "",
      telefono: "",
      privacy: "",
      data: "",
      persone: 2,
      idsala: 0,
      chiuso: false,
      caricamento: false,
      scelta: { servizio: "", orario: "" },
      form: { nome: "", telefono: "", email: "", note: "", privacy: false, sito: "" },
      errori: {},
      messaggi: [],
      invio: false,
      fatta: null,
      emailInviata: false
    };
  },
  watch: {
    // Lingua cambiata dalla barra in alto: testi e privacy nella nuova lingua.
    "$store.lang"(nuova, vecchia) {
      if (nuova && vecchia && nuova.toLowerCase() !== vecchia.toLowerCase()) {
        this.caricaConfigurazione();
      }
    }
  },
  mounted() {
    // Parametri come nel Booking: in POST dal sito dell'hotel o nell'indirizzo.
    const post = typeof this.$postData !== "undefined" && this.$postData && this.$postData.RPC_db ? this.$postData : null;
    const q = post || this.$route.query;
    this.$store.db = q.RPC_db || "";
    this.$store.idhotel = q.idhotel || "";
    this.$store.lang = (q.lan || "ita").toUpperCase();
    paginaService.neutra(this);
    if (!this.$store.db || !this.$store.idhotel) {
      this.errore = "ERR_RPC";
      return;
    }
    // Lingue della barra in alto.
    this.$root.$emit("lang:request", this.$store.lang);
    this.caricaConfigurazione();
  },
  methods: {
    t(chiave) {
      return this.testi[chiave] || chiave;
    },
    iniziale(testo) {
      return testo ? testo.charAt(0).toUpperCase() + testo.slice(1) : "";
    },
    lingua() {
      return String(this.$store.lang || "ita").toLowerCase();
    },
    caricaConfigurazione() {
      apiService
        .get("BE_ristorante/" + this.$store.db + "/" + this.$store.idhotel + "/" + this.lingua())
        .then((resp) => {
          this.testi = resp.testi || {};
          paginaService.applica(this, resp.grafica);
          this.servizi = (resp.servizi || []).map((id) => ({ id, orari: [], disponibile: false }));
          this.maxPersone = resp.maxPersone || 8;
          this.oggi = resp.oggi;
          this.ultimo = resp.ultimo;
          this.sale = resp.sale || [];
          this.nota = resp.nota || "";
          this.telefono = String(resp.telefono || "").trim();
          this.privacy = resp.privacy || "";
          this.persone = Math.min(this.persone, this.maxPersone);
          if (!this.data) {
            this.data = this.oggi;
          }
          this.pronta = true;
          this.caricaDisponibilita();
        })
        .catch((resp) => {
          this.testi = (resp && resp.testi) || this.testi;
          this.errore = (resp && resp.errori && resp.errori[0]) || "ERR_GENERIC";
        });
    },
    caricaDisponibilita() {
      this.scelta = { servizio: "", orario: "" };
      if (!this.data) {
        return;
      }
      this.caricamento = true;
      apiService
        .get("BE_ristorante/disponibilita/" + this.$store.db + "/" + this.$store.idhotel + "?data=" + this.data + "&persone=" + this.persone + "&idsala=" + this.idsala)
        .then((resp) => {
          this.caricamento = false;
          this.chiuso = !!resp.chiuso;
          this.servizi = resp.servizi || [];
        })
        .catch(() => (this.caricamento = false));
    },
    cambiaPersone(delta) {
      const n = Math.max(1, Math.min(this.maxPersone, this.persone + delta));
      if (n !== this.persone) {
        this.persone = n;
        this.caricaDisponibilita();
      }
    },
    scegli(servizio, orario) {
      this.scelta = { servizio, orario };
      this.$nextTick(() => this.$refs.dati && this.$refs.dati.scrollIntoView({ behavior: "smooth", block: "start" }));
    },
    dataLunga(sql) {
      if (!sql) {
        return "";
      }
      const [a, m, g] = sql.split("-").map(Number);
      return new Date(a, m - 1, g).toLocaleDateString(LOCALI[this.lingua()] || "it-IT", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
    },
    prenota() {
      if (this.invio) {
        return;
      }
      this.invio = true;
      this.errori = {};
      this.messaggi = [];
      apiService
        .post("BE_ristorante/prenota/" + this.$store.db + "/" + this.$store.idhotel + "/" + this.lingua(), {
          ...this.form,
          data: this.data,
          servizio: this.scelta.servizio,
          orario: this.scelta.orario,
          persone: this.persone,
          idsala: this.idsala
        })
        .then((resp) => {
          this.invio = false;
          this.fatta = resp.prenotazione;
          this.emailInviata = !!resp.email;
          window.scrollTo(0, 0);
        })
        .catch((resp) => {
          this.invio = false;
          this.errori = (resp && resp.errors) || {};
          this.messaggi = (resp && resp.errori) || ["ERR_GENERIC"];
          // Il tavolo e' stato preso nel frattempo: si rilegge la disponibilita'.
          if (this.messaggi.includes("RIST_ErrOccupato") || this.messaggi.includes("RIST_ErrOrario")) {
            const scelta = this.scelta;
            this.caricaDisponibilita();
            this.scelta = scelta;
          }
        });
    },
    ricomincia() {
      this.fatta = null;
      this.form = { nome: this.form.nome, telefono: this.form.telefono, email: this.form.email, note: "", privacy: false, sito: "" };
      this.caricaDisponibilita();
    }
  }
};
</script>

<style lang="scss">
@import "../css/variables.scss";

// Sotto la barra dell'hotel, come le altre pagine del Booking (.home).
.rist {
  position: absolute;
  top: 7em;
  left: 0;
  right: 0;
  max-width: 820px;
  margin: 20px auto 40px;
  padding: 0 12px;
  text-align: left;
}
@media (max-width: 576px) {
  .rist {
    top: 11em;
  }
}
.rist-card {
  background: rgba(255, 255, 255, 0.96);
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 16px;
}
.rist-titolo {
  font-size: 1.3em;
  font-weight: 600;
  color: var(--base-color);
  margin: 0 0 12px;
}
.rist-nota {
  background: #f6f7f9;
  border-left: 4px solid var(--base-color);
  padding: 8px 12px;
  margin-bottom: 12px;
  font-size: 0.9em;
}
.rist-riga {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  align-items: flex-end;
}
.rist-campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 180px;
  flex: 1 1 180px;
  margin-bottom: 8px;
  span {
    font-size: 0.8em;
    font-weight: 600;
    color: $muted;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
  input,
  select,
  textarea {
    border: 1px solid #d5d9e0;
    border-radius: 6px;
    padding: 8px 10px;
    font: inherit;
    color: $text;
    background: #fff;
  }
  input[type="date"] {
    text-align: center;
    &::-webkit-date-and-time-value {
      text-align: center;
    }
  }
  &.largo {
    flex-basis: 100%;
  }
  &.rist-err input,
  &.rist-err textarea {
    border-color: $negative;
  }
}
.rist-contatore {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 4px;
  font-size: 1.1em;
  svg {
    color: var(--base-color);
  }
}
.rist-sub {
  font-size: 0.85em;
  color: #6b7280;
}
.rist-centro {
  text-align: center;
  margin-top: 6px;
}
.rist-attesa {
  padding: 16px;
  text-align: center;
}
.rist-servizio {
  margin-top: 14px;
}
.rist-servizio-nome {
  font-weight: 600;
  margin-bottom: 6px;
}
.rist-orari {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.rist-orario {
  border: 2px solid var(--base-color);
  color: var(--base-color);
  border-radius: 20px;
  padding: 5px 14px;
  cursor: pointer;
  user-select: none;
  font-weight: 600;
  &:hover {
    background: var(--base-light);
  }
  &.scelto {
    background: var(--base-color);
    color: #fff;
  }
}
.rist-scelta {
  font-weight: 600;
  margin-bottom: 12px;
}
.rist-avviso {
  color: $negative;
  font-weight: 600;
  margin: 10px 0;
}
.rist-privacy {
  margin-top: 6px;
}
.rist-privacy-testo {
  max-height: 120px;
  overflow: auto;
  font-size: 0.75em;
  background: #f6f7f9;
  padding: 8px;
  border-radius: 6px;
  white-space: pre-wrap;
}
.rist-accetto {
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 10px 0;
  &.rist-err {
    color: $negative;
    font-weight: 600;
  }
}
.rist-civetta {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  opacity: 0;
}
.rist-btn {
  background: var(--base-color);
  color: #fff;
  text-align: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  user-select: none;
  margin-top: 8px;
  &.disabilitato {
    opacity: 0.6;
    pointer-events: none;
  }
}
.rist-messaggio {
  text-align: center;
  h2 {
    font-size: 1.3em;
    margin: 12px 0;
  }
}
.rist-icona-grande {
  font-size: 2.6em;
  color: var(--base-color);
}
.rist-riepilogo {
  display: inline-block;
  text-align: left;
  margin: 8px 0 12px;
  div {
    display: flex;
    gap: 16px;
    justify-content: space-between;
    padding: 3px 0;
    border-bottom: 1px solid #eef0f3;
  }
  span {
    color: #6b7280;
  }
  b::first-letter {
    text-transform: uppercase;
  }
}
</style>
